export enum PlaceholderId {
  FirstName = '[first_name]',
  LastName = '[last_name]',
  Candidate = '[candidate]',
  Recruiter = '[recruiter]',
  JobOffer = '[job_offer]',
  Company = '[company]',
  Department = '[department]',
  EventTitle = '[event_title]',
}

export type PlaceholderStatus = { invalid: boolean; message: string } | null;
export type PlaceholderData = {
  value: string | null;
  description?: string | null;
  status?: PlaceholderStatus;
};
export type PlaceholderConfig = { disabled?: boolean; overrideTooltipText?: string };
export type PlaceholderConfigMap = Record<string, PlaceholderConfig>;

export class Placeholder {
  public readonly interpolated: boolean;
  public readonly value: string;

  constructor(public readonly id: PlaceholderId | 'empty', public readonly data: PlaceholderData) {
    this.value = this.data.value || this.id;
    this.interpolated = this.id !== this.value;
  }

  public toString(): string {
    return this.id;
  }

  public clone(data: { description: string; value: string }): Placeholder {
    return new Placeholder(this.id, { ...this.data, ...data });
  }
}
